import { render, staticRenderFns } from "./comeunity.vue?vue&type=template&id=37d67e76&scoped=true&"
import script from "./comeunity.vue?vue&type=script&lang=js&"
export * from "./comeunity.vue?vue&type=script&lang=js&"
import style0 from "./comeunity.vue?vue&type=style&index=0&id=37d67e76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d67e76",
  null
  
)

export default component.exports